/**
 * Lightweight analytics facade.
 *
 * Plausible is loaded directly in /app/frontend/public/index.html (custom
 * tagged-events snippet) so `window.plausible()` is available globally.
 *
 * PostHog is auto-injected by the Emergent platform on production deploys.
 * We forward events to both when present.
 */

/**
 * Fire a custom analytics event.
 * @param {string} name  event name (kebab-case, e.g. "partner-hero-cta-click")
 * @param {object} [props]  custom properties (passed as `props:` to Plausible)
 */
export const track = (name, props) => {
  try {
    if (typeof window === "undefined") return;
    if (typeof window.plausible === "function") {
      window.plausible(name, props ? { props } : undefined);
    }
    if (window.posthog && typeof window.posthog.capture === "function") {
      window.posthog.capture(name, props || {});
    }
  } catch {
    // Never let analytics break the app
  }
};

/**
 * Manual pageview event — useful for SPA route changes if you ever want to
 * override Plausible's default behaviour.
 */
export const trackPageView = (path) => {
  try {
    if (typeof window !== "undefined" && typeof window.plausible === "function") {
      window.plausible("pageview", path ? { u: `${window.location.origin}${path}` } : undefined);
    }
  } catch {
    // noop
  }
};
